import {
  assignees,
  inputClass,
} from "../../manageLead/shared";

import {
  FormActions,
  Label,
  MiniNotice,
  QuickButton,
  ReadonlyRow,
} from "./UI";

/* -------------------------------------------------------------------------- */
/*                               FOLLOW-UP                                    */
/* -------------------------------------------------------------------------- */

export function FollowupForm({
  form,
  setForm,
  updating,
  onSubmit,
  onCancel,
  onQuickDate,
  followupMode = "normal",
  currentAssignee,
}) {
  const isL2 =
    followupMode === "l2";

  const selfSelected =
    form.followupOwner === "self";

  const level1Selected =
    form.followupOwner === "level-1";

  return (
    <form
      onSubmit={onSubmit}
      className="space-y-3"
    >
      {/* L2 FOLLOW-UP OWNER */}

      {isL2 && (
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
          <p className="mb-2 text-xs font-semibold text-slate-700">
            Who will handle this follow-up?
          </p>

          <div className="grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={() =>
                setForm((prev) => ({
                  ...prev,

                  followupOwner:
                    "self",

                  assignedTo:
                    currentAssignee,

                  level:
                    "level-2",
                }))
              }
              className={`rounded-xl border px-2.5 py-2.5 text-[11px] font-semibold leading-4 transition sm:px-3 sm:py-3 sm:text-xs ${
                selfSelected
                  ? "border-slate-900 bg-slate-900 text-white"
                  : "border-slate-200 bg-white text-slate-700 hover:border-slate-400"
              }`}
            >
              I Will Follow Up
            </button>

            <button
              type="button"
              onClick={() =>
                setForm((prev) => ({
                  ...prev,

                  followupOwner:
                    "level-1",

                  assignedTo: "",

                  level:
                    "level-1",
                }))
              }
              className={`rounded-xl border px-2.5 py-2.5 text-[11px] font-semibold leading-4 transition sm:px-3 sm:py-3 sm:text-xs ${
                level1Selected
                  ? "border-slate-900 bg-slate-900 text-white"
                  : "border-slate-200 bg-white text-slate-700 hover:border-slate-400"
              }`}
            >
              Assign to Level 1
            </button>
          </div>
        </div>
      )}

      {/* L2 SELF */}

      {isL2 &&
        selfSelected && (
          <ReadonlyRow
            label="Follow-up By"
            value={
              currentAssignee
            }
          />
        )}

      {/* L2 → L1 */}

      {isL2 &&
        level1Selected && (
          <div>
            <Label>
              Level 1 Representative *
            </Label>

            <select
              className={
                inputClass
              }
              value={
                form.assignedTo
              }
              onChange={(e) =>
                setForm(
                  (prev) => ({
                    ...prev,

                    assignedTo:
                      e.target.value,

                    level:
                      "level-1",
                  })
                )
              }
            >
              <option value="">
                Select Level 1 Representative
              </option>

              {assignees.map(
                (person) => (
                  <option
                    key={person}
                    value={person}
                  >
                    {person}
                  </option>
                )
              )}
            </select>
          </div>
        )}

      {/* NORMAL L1 */}

      {!isL2 && (
        <ReadonlyRow
          label="Follow-up By"
          value={
            currentAssignee
          }
        />
      )}

      {/* NOTE */}

      <div>
        <Label>
          Follow-up Note
        </Label>

        <textarea
          className={`${inputClass} min-h-20 resize-none`}
          placeholder="Add follow-up note..."
          value={form.notes}
          onChange={(e) =>
            setForm(
              (prev) => ({
                ...prev,

                notes:
                  e.target.value,
              })
            )
          }
        />
      </div>

      {/* QUICK DATES */}

      <div>
        <Label>
          Follow-up Time (IST)
        </Label>

        <div className="grid grid-cols-3 gap-2">
          <QuickButton
            onClick={() =>
              onQuickDate(1)
            }
          >
            Tomorrow
          </QuickButton>

          <QuickButton
            onClick={() =>
              onQuickDate(3)
            }
          >
            In 3 Days
          </QuickButton>

          <QuickButton
            onClick={() =>
              onQuickDate(7)
            }
          >
            Next Week
          </QuickButton>
        </div>
      </div>

      <input
        type="datetime-local"
        className={inputClass}
        value={
          form.followupAt
        }
        onChange={(e) =>
          setForm(
            (prev) => ({
              ...prev,

              followupAt:
                e.target.value,
            })
          )
        }
      />

      <FormActions
        updating={updating}
        submitText="Schedule Follow-up"
        onCancel={onCancel}
      />
    </form>
  );
}

/* -------------------------------------------------------------------------- */
/*                        CUSTOMER WILL CALL BACK                             */
/* -------------------------------------------------------------------------- */

export function CustomerCallbackForm({
  form,
  setForm,
  updating,
  onSubmit,
  onCancel,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="space-y-3"
    >
      <MiniNotice>
        Status will remain{" "}
        <strong>
          Contacted
        </strong>
        . No automatic follow-up will be scheduled.
      </MiniNotice>

      <div>
        <Label>
          Note *
        </Label>

        <textarea
          autoFocus
          className={`${inputClass} min-h-24 resize-none`}
          placeholder="Example: Customer will call after discussing with family..."
          value={form.notes}
          onChange={(e) =>
            setForm(
              (prev) => ({
                ...prev,

                notes:
                  e.target.value,
              })
            )
          }
        />
      </div>

      <FormActions
        updating={updating}
        submitText="Save"
        onCancel={onCancel}
      />
    </form>
  );
}

/* -------------------------------------------------------------------------- */
/*                           SEND TO LEVEL 2                                  */
/* -------------------------------------------------------------------------- */

export function TransferL2Form({
  form,
  setForm,
  updating,
  onSubmit,
  onCancel,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="space-y-3"
    >
      {/* ONLY NOTE */}

      <div>
        <Label>
          Note *
        </Label>

        <textarea
          autoFocus
          className={`${inputClass} min-h-24 resize-none`}
          placeholder="Add note for the Level 2 representative..."
          value={
            form.notes
          }
          onChange={(e) =>
            setForm(
              (prev) => ({
                ...prev,

                notes:
                  e.target.value,
              })
            )
          }
        />
      </div>

      <FormActions
        updating={updating}
        submitText="Send to L2"
        onCancel={onCancel}
      />
    </form>
  );
}

/* -------------------------------------------------------------------------- */
/*                                  CLOSE                                     */
/* -------------------------------------------------------------------------- */

export function CloseLeadForm({
  closeType,
  form,
  setForm,
  updating,
  onSubmit,
  onCancel,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="space-y-3"
    >
      <div>
        <Label>
          {closeType ===
          "wrong_number"
            ? "Wrong Number Note *"
            : "Why is the lead not interested? *"}
        </Label>

        <textarea
          autoFocus
          className={`${inputClass} min-h-24 resize-none`}
          placeholder="Add note..."
          value={
            form.notes
          }
          onChange={(e) =>
            setForm(
              (prev) => ({
                ...prev,

                notes:
                  e.target.value,
              })
            )
          }
        />
      </div>

      <FormActions
        updating={updating}
        submitText="Save & Close"
        onCancel={onCancel}
      />
    </form>
  );
}

/* -------------------------------------------------------------------------- */
/*                                  BOOKED                                    */
/* -------------------------------------------------------------------------- */

export function BookedForm({
  form,
  setForm,
  bookedBy,
  bookedAt,
  updating,
  onSubmit,
  onCancel,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="space-y-3"
    >
      <ReadonlyRow
        label="Booked By"
        value={
          bookedBy
        }
      />

      <ReadonlyRow
        label="Booked At"
        value={
          bookedAt
        }
      />

      <div>
        <Label>
          Booking Price *
        </Label>

        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-500">
            ₹
          </span>

          <input
            type="number"
            min="1"
            step="1"
            className={`${inputClass} pl-7`}
            placeholder="15000"
            value={
              form.price
            }
            onChange={(e) =>
              setForm(
                (prev) => ({
                  ...prev,

                  price:
                    e.target.value,
                })
              )
            }
          />
        </div>
      </div>

      <div>
        <Label>
          Booking Note *
        </Label>

        <textarea
          className={`${inputClass} min-h-24 resize-none`}
          placeholder="Add booking details..."
          value={
            form.notes
          }
          onChange={(e) =>
            setForm(
              (prev) => ({
                ...prev,

                notes:
                  e.target.value,
              })
            )
          }
        />
      </div>

      <FormActions
        updating={updating}
        submitText="Confirm Booking"
        onCancel={onCancel}
      />
    </form>
  );
}